import { Facebook, Instagram, Mail, MapPin, Phone } from "lucide-react";
import { CLINIC, IMAGES } from "@/lib/clinic";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-navy-900 text-cream pt-20 pb-10"
    >
      <div className="section-container grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <div className="flex items-center gap-4">
            <img
              src={IMAGES.logo}
              alt="Salud Ocular"
              className="h-20 w-20 object-contain rounded-2xl bg-cream p-2"
            />
            <div className="leading-none">
              <p className="font-display text-[26px] font-semibold tracking-tight">Salud Ocular</p>
              <p className="mt-2 text-[10px] tracking-[0.26em] uppercase text-turquoise-300 font-semibold">
                Instituto Oftalmológico
              </p>
            </div>
          </div>
          <p className="mt-6 text-cream/70 text-sm leading-relaxed max-w-sm">
            Cuidamos tu visión con tecnología avanzada y una atención cercana. Paraná, Entre Ríos.
          </p>

          <div className="mt-8 flex items-center gap-3">
            <a
              href={CLINIC.facebook}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              data-testid="footer-facebook"
              className="w-10 h-10 rounded-full bg-white/10 hover:bg-turquoise-500 hover:text-navy-900 transition-colors flex items-center justify-center"
            >
              <Facebook className="w-4 h-4" />
            </a>
            <a
              href={CLINIC.instagram}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              data-testid="footer-instagram"
              className="w-10 h-10 rounded-full bg-white/10 hover:bg-turquoise-500 hover:text-navy-900 transition-colors flex items-center justify-center"
            >
              <Instagram className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div className="lg:col-span-3 grid grid-cols-2 gap-8 content-start">
          <div>
            <p className="text-[11px] tracking-[0.22em] uppercase text-turquoise-300 font-semibold">
              Navegación
            </p>
            <ul className="mt-4 space-y-3 text-sm text-cream/80">
              <li><a href="#patologias" className="hover:text-turquoise-300">Patologías</a></li>
              <li><a href="#obras-sociales" className="hover:text-turquoise-300">Obras Sociales</a></li>
              <li><a href="#equipo" className="hover:text-turquoise-300">Equipo</a></li>
              <li><a href="#ubicacion" className="hover:text-turquoise-300">Ubicación</a></li>
            </ul>
          </div>
          <div>
            <p className="text-[11px] tracking-[0.22em] uppercase text-turquoise-300 font-semibold">
              Contacto
            </p>
            <ul className="mt-4 space-y-3 text-sm text-cream/80">
              <li className="flex gap-2"><MapPin className="w-4 h-4 text-turquoise-300 shrink-0 mt-0.5" /><span>{CLINIC.address}</span></li>
              <li className="flex gap-2"><Phone className="w-4 h-4 text-turquoise-300 shrink-0 mt-0.5" /><span>{CLINIC.phoneDisplay}</span></li>
              <li className="flex gap-2"><Mail className="w-4 h-4 text-turquoise-300 shrink-0 mt-0.5" /><a href={`mailto:${CLINIC.email}`} className="hover:text-turquoise-300 break-all">{CLINIC.email}</a></li>
            </ul>
          </div>
        </div>

        <div className="lg:col-span-5">
          <p className="text-[11px] tracking-[0.22em] uppercase text-turquoise-300 font-semibold">
            Cómo llegar
          </p>
          <div
            data-testid="google-maps-embed"
            className="mt-4 relative rounded-2xl overflow-hidden h-64 w-full border border-white/10"
          >
            <iframe
              title="Mapa Salud Ocular - Cervantes 732, Paraná"
              src={CLINIC.mapsEmbed}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
          <a
            href={CLINIC.mapsLink}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-maps-link"
            className="mt-3 inline-flex items-center gap-2 text-sm text-turquoise-300 hover:text-turquoise-200"
          >
            <MapPin className="w-4 h-4" /> Abrir en Google Maps
          </a>
        </div>
      </div>

      <div className="section-container mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-cream/50">
          © {new Date().getFullYear()} Salud Ocular · Instituto Oftalmológico. Todos los derechos reservados.
        </p>
        <p className="text-xs text-cream/50">
          Paraná, Entre Ríos · Argentina
        </p>
      </div>
    </footer>
  );
}
